(function () {
  function loadScript(src, attrs) {
    if (document.querySelector('script[src="' + src + '"]')) {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      if (attrs) {
        Object.keys(attrs).forEach(function (key) {
          script.setAttribute(key, attrs[key]);
        });
      }
      script.onload = resolve;
      script.onerror = resolve;
      document.body.appendChild(script);
    });
  }

  function isDesignMode() {
    return window.Shopify && Shopify.designMode;
  }

  function loadLottie() {
    if (window.__ariLottieLoading) return;
    window.__ariLottieLoading = true;
    loadScript('https://unpkg.com/@lottiefiles/lottie-player@2.0.12/dist/lottie-player.js').then(function () {
      return loadScript(
        'https://unpkg.com/@lottiefiles/lottie-interactivity@1.6.2/dist/lottie-interactivity.min.js'
      );
    });
  }

  function watchLottie() {
    if (document.querySelector('lottie-player')) {
      loadLottie();
      return;
    }

    if (!('MutationObserver' in window)) return;
    var observer = new MutationObserver(function () {
      if (document.querySelector('lottie-player')) {
        observer.disconnect();
        loadLottie();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function reinitElfsight() {
    if (window.eapps && typeof window.eapps.initialize === 'function') {
      window.eapps.initialize();
    }
  }

  function hydrateElfsight(placeholder) {
    var className = placeholder.getAttribute('data-elfsight-class');
    if (!className || placeholder.getAttribute('data-loaded') === 'true') return;
    placeholder.setAttribute('data-loaded', 'true');
    var widget = document.createElement('div');
    widget.className = className;
    placeholder.appendChild(widget);
    loadScript('https://static.elfsight.com/platform/platform.js', { defer: 'true' }).then(reinitElfsight);
  }

  function lazyElfsight() {
    var nodes = document.querySelectorAll('.js-lazy-elfsight');
    if (!nodes.length) return;

    nodes.forEach(function (node) {
      if (!node.style.minHeight) node.style.minHeight = '240px';
    });

    function hydrateAll() {
      nodes.forEach(hydrateElfsight);
    }

    if (isDesignMode() || !('IntersectionObserver' in window)) {
      hydrateAll();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          hydrateElfsight(entry.target);
        });
      },
      { rootMargin: '300px 0px' }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });

    window.addEventListener('resize', function () {
      nodes.forEach(function (node) {
        if (node.getAttribute('data-loaded') === 'true') return;
        if (node.getClientRects().length) hydrateElfsight(node);
      });
    });
  }

  function boot() {
    lazyElfsight();
    watchLottie();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
